import { showMessage, showPopup, closePopup } from "./uiActions";
import { BlobServiceClient } from '@azure/storage-blob';
import { saveAs } from 'file-saver'

export function sendLogin(username, password) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "User Logging In..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/users/login`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                Email: username,
                Password: password,
                RememberMe: false
            })
            }).then((resp) => {
             // handle bad exceptions and get the right error message
                if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
            })
            .then((json) => {
                if (json === "User is locked out, please try again after one hour") {
                    return dispatch(showPopup("confirmationPopup", "User is locked out, please try again after one hour", false))
                } else {
                    localStorage.setItem("jwt_token", json.token)
                    return dispatch(loginSuccessful(json.user, json.roles[0], json.customerName, json.customerMessage, json.customerNotes, json.custDBList, json.custFolderList))
                }
            }).catch(ex => {
                console.log(ex)
                return dispatch(showPopup("confirmationPopup", "User Login Failed. Please Try Again", false))
            })
    }
}

export function sendLoginSSO(code) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "User Logging In..."))
        dispatch(ssoFlag())
        fetch(`${process.env.REACT_APP_BACK_URL}/users/login-microsoft?code=${code}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            },
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                if (resp.status === 401) {
                    throw new Error("Cannot Create New User As This Exceeds The Allowed Number of License Activations For Client")
                } else {
                    throw new Error("User Login Failed. Please Try Again")
                }
            } else {
                return resp.json()
            }
        })
            .then((json) => {
                if (json === "User is locked out, please try again after one hour") {
                    return dispatch(showPopup("confirmationPopup", "User is locked out, please try again after one hour", false))
                } else {
                    localStorage.setItem("jwt_token", json.token)
                    // dispatch(closePopup())
                    return dispatch(loginSuccessful(json.user, json.roles[0], json.customerName, json.customerMessage, json.customerNotes, json.custDBList, json.custFolderList))
                }
            }).catch(ex => {
                dispatch(ssoFail())
                return dispatch(showPopup("confirmationPopup", ex.toString(), false))
            })
    }
}

export function sendLoginPepsiSSO(jtoken) {
    return function (dispatch) {
        console.log("PepsiSSO Send")
        dispatch(showPopup("loadingPopup", "User Logging In..."))
        dispatch(ssoFlag())
        fetch(`${process.env.REACT_APP_BACK_URL}/users/login-pepsi2?jtoken=${jtoken}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            },
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                console.log("PepsiSSO received")
                return resp.json()
            }
        })
            .then((json) => {
                if (json === "User is locked out, please try again after one hour") {
                    return dispatch(showPopup("confirmationPopup", "User is locked out, please try again after one hour", false))
                } else {
                    localStorage.setItem("jwt_token", json.token)
                    // dispatch(closePopup())
                    return dispatch(loginSuccessful(json.user, json.roles[0], json.customerName, json.customerMessage, json.customerNotes, json.custDBList, json.custFolderList ))
                }
            }).catch(ex => {
                dispatch(ssoFail())
                return dispatch(showPopup("confirmationPopup", "User Login Failed. Please Try Again", false))
            })
    }
}

export function sendEditUser(id, firstName,lastName, email, customerID, role, teamIDs, isEnabled, claims=[]) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Editing User..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/users/${id}`, {
            method: 'PATCH',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                firstName: firstName,
                lastName: lastName,
                Email: email,
                CustomerID: customerID,
                Role: role,
                TeamIDs: teamIDs,
                Claims: claims,
                IsEnabled: isEnabled,
            })
        }).then((resp) => {
            if (resp.status !== 200) {
                if (resp.status === 401) {
                    dispatch(showPopup("confirmationPopup", "Adding User Exceeds Allowed Number of License Activations For Client", false))
                }  else if (resp.status === 409) {
                    dispatch(showPopup("confirmationPopup", "Email Address Already Exists", false))
                } else {
                    dispatch(showPopup("confirmationPopup", "Edit User was Unsuccessful", false))
                }
                // good response flow
            } else {
                dispatch(getUsers(false))
                return dispatch(showPopup("confirmationPopup", "Edit User Successful"))
            }
        })
    }
}

export function changePassword(id, email, prevPW, newPW, confirmNewPW) {
    return function (dispatch) {
        if (newPW !== confirmNewPW) {
            return dispatch(showMessage("Passwords do not match", false))
        }
        fetch(`${process.env.REACT_APP_BACK_URL}/users/${id}/password`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                Email: email,
                PreviousPW: prevPW,
                NewPW: newPW,
                ConfirmNewPW: confirmNewPW,
            })
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                dispatch(showMessage("Change Password was Unsuccessful", false))
            } else {
                return dispatch(showPopup("confirmationPopup", "Password Change is Successful"))
            }
        })
    }
}

export function recoverLogin() {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/users/persist`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                throw new Error("Token is Invalid or Expired, Please Sign in Again", false)
                // good response flow
            } else {
                return resp.json()
            }
        })
        .then((json) => {
            // console.log(json)
            return dispatch(loginSuccessful(json.user, json.roles[0], json.customerName, json.customerMessage, json.customerNotes, json.custDBList, json.custFolderList))
            }).catch((ex) => {
                return localStorage.removeItem('jwt_token')
            })
    }
}

export function getCurrentUser(id) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/users/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
            }).then((json) => {
            return dispatch(loadUser(json.user))
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup", "Get User Failed", false))
            })
    }
}

export function getUsers(flag = true) {
    return function (dispatch) {
        dispatch(flipUsersSwitch())
        dispatch(showPopup("loadingPopup", "Getting Users"))
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/users`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                throw new Error()
                // good response flow
            } else {
                return resp.json()
            }
            }).then((json) => {
            if (flag) {
                dispatch(closePopup())
                }
            return dispatch(showUsers(json.userList, json.rolesList))
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup", "Get Users Failed. Please Try Again", false))
            })

    }
}

export function createUser(firstName, lastName, username, customerID, role, teamIDs, pw, confirmPW) {
    return function (dispatch) {
        if (pw !== confirmPW) {
            return dispatch(showMessage("Passwords do not Match", false))
        }
        fetch(`${process.env.REACT_APP_BACK_URL}/users`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                FirstName: firstName,
                LastName: lastName,
                Email: username,
                CustomerID: customerID,
                Role: role,
                TeamIDs: teamIDs,
                Password: pw,
            })
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                if (resp.status === 401) {
                    throw new Error("Adding User Exceeds Allowed Number of License Activations For Client")
                } else if (resp.status === 409) {
                    throw new Error("Email Address Already Exists")
                } else if (resp.status === 422) {
                    throw new Error("License Key Does Not Exists For Client")
                } else {
                    throw new Error("User Creation Failed. Please Try Again")
                }
                // good response flow
            } else {
                dispatch(getUsers(false))
                return dispatch(showPopup("confirmationPopup", "User Was Successfully Created"))
            }
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup", ex.toString(), false))
            })
    }
}

export function registerUser(username, pw, confirmPW, custGUID) {
    return function (dispatch) {
        if (pw !== confirmPW) {
            return dispatch(showMessage("Passwords do not match", false))
        }
        dispatch(showPopup("loadingPopup", "Registering User..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/users/register`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                Email: username,
                Password: pw,
                CustGUID: custGUID, 
            })
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                throw new Error("User Creation Failed. Please Try Again")
                // good response flow
            } else {
                return dispatch(showPopup("confirmationPopup", "User Was Successfully Registered, Please check your email for the Activation link."))
            }
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "User Registration Failed. Please Try Again", false))
        })
    }
}

export function sendEmailActivation(userID, emailCode) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Activating User..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/users/activate`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                UserID: userID,
                EmailCode: emailCode,
            })
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                throw new Error("User Activation Failed. Please Try Again")
                // good response flow
            } else {
                dispatch(activationCheck())
                return dispatch(showPopup("confirmationPopup", "User Was Successfully Activated"))
            }
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "User Activation Failed. Code has expired.", false))
        })
    }
}


export function createCustomer(name) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Creating Customer..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/customers`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                CustomerName: name
            })
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error("Add Customer Failed")
            } else {
                dispatch(getCustomers())
                dispatch(getTeams())
                return dispatch(showPopup("confirmationPopup", "Add Customer Was Successful"))
            }
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup", "Add Customer Failed", false))
            })
    }
}

export function editCustomer(id,viewer,builder) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Editing Customer..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/customers/license`, {
            method: 'PATCH',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                CustomerID: id,
                ViewerLicenseId: viewer,
                BuilderLicenseId: builder
            })
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error("Edit Customer Failed")
            } else {
                dispatch(getCustomers())
                return dispatch(showPopup("confirmationPopup", "Edit Customer Was Successful"))
            }
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup", "Edit Customer Failed", false))
            })
    }
}

export function updateCustomerMessage(customerID, message) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/customers/${customerID}/message`, {
            method: 'PATCH',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify(
                {
                    CustomerID: customerID,
                    Message: message,
                }
            )
        }).then((resp) => {
            // console.log(resp)
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()

            }
            }).then(json => {
                dispatch(setCustomerMessage(json.customer.message))
                return dispatch(showMessage("Edit Message Was Successful", true))
            }).catch((ex) => {
            return dispatch(showMessage("Edit Message Failed", false))
        })
    }
}

export function updateCustomerNotes(customerID, notes) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/customers/${customerID}/notes`, {
            method: 'PATCH',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify(
                {
                    CustomerID: customerID,
                    Notes: notes,
                }
            )
        }).then((resp) => {
            // console.log(resp)
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()

            }
        }).then(json => {
            dispatch(setCustomerNotes(json.customer.notes))
            return dispatch(showMessage("Edit Notes Was Successful", true))
        }).catch((ex) => {
            return dispatch(showMessage("Edit Notes Failed", false))
        })
    }
}

export function getCustomers() {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/customers`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error("Customers Unavailable")
            } else {
                return resp.json()
            }
            }).then((json) => {
                return dispatch(showCustomers(json.custList))
            }).catch((ex) => {
                return dispatch(showMessage("Customers Unavailable"))
            })
    }
}

export function getPermissions() {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/permissions`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error("Permissions Unavailable")
            } else {
                return resp.json()
            }
        }).then((json) => {
            return dispatch(showPermissions(json.permissions))
        }).catch((ex) => {
            return dispatch(showMessage("Permissions Unavailable"))
        })
    }
}

export function getTeams() {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/teams`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error("Teams Unavailable")
            } else {
                return resp.json()
            }
            }).then((json) => {
                return dispatch(showTeams(json.teamList))
            }).catch((ex) => {
                return dispatch(showMessage("Teams Unavailable"))
            })
        
    }
}

export function getFolders() {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/folders`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error("Folders Unavailable")
            } else {
                return resp.json()
            }
        }).then((json) => {
            return dispatch(showFolders(json.folderList))
        }).catch((ex) => {
            return dispatch(showMessage("Folders Unavailable"))
        })

    }
}

export function getDatabases() {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/databases`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error("Databases Unavailable")
            } else {
                return resp.json()
            }
        }).then((json) => {
            return dispatch(showDatabases(json.databaseList))
        }).catch((ex) => {
            return dispatch(showMessage("Databases Unavailable"))
        })

    }
}


export function resetUserPassword(id, newPW, confirmNewPW) {
    return function (dispatch) {
        if (newPW !== confirmNewPW) {
            return dispatch(showMessage("Passwords Do Not Match", false))
        }
        dispatch(showPopup("loadingPopup", "Changing User Password..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/users/${id}/reset`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                ID: id,
                NewPW: newPW,
            })
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
               return dispatch(showPopup("confirmationPopup", "Password Successfully Reset"))
            }
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup", "Reset Password Failed", false))
            })
    }
}

export function deleteUser(id) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Deleting User..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/users/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                throw new Error()
                // good response flow
            } else {
                dispatch(getUsers(false))
                return dispatch(showPopup("confirmationPopup", "Delete User Was Successful"))
            }
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup", "Delete User Was Unsuccessful", false))
            })
    }
}

export function disableUser(id) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Disabling User..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/users/${id}`, {
            method: 'UPDATE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                throw new Error()
                // good response flow
            } else {
                dispatch(getUsers(false))
                return dispatch(showPopup("confirmationPopup", "Disable User Was Successful"))
            }
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Disable User Was Unsuccessful", false))
        })
    }
}

export function createTeam(teamName, customerID) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/teams`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                TeamName: teamName,
                CustomerID: customerID,
            })
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                throw new Error("Team Creation Failed. Please Try Again")
                // good response flow
            } else {
                //? getTeams Call goes here ?????? 
                dispatch(getCustomers())
                dispatch(getTeams())
                return dispatch(showPopup("confirmationPopup", "Team Was Successfully Created"))
            }
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Team Creation Failed. Please Try Again", false))
        })
    }
}

export function sendDeleteTeam(id) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Deleting Team..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/teams/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                throw new Error()
                // good response flow
            } else {
                dispatch(getTeams())
                dispatch(getUsers(false))
                return dispatch(showPopup("confirmationPopup", "Delete Team Was Successful"))
            }
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Delete Team Was Unsuccessful", false))
        })
    }
}

export function sendEditTeam(teamID, name, customerID) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/teams`, {
            method: 'PATCH',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                Name: name,
                TeamID: teamID,
                CustomerID: customerID,
            })
        }).then((resp) => {
            if (resp.status !== 200) {
                dispatch(showPopup("confirmationPopup", "Edit Team was Unsuccessful", false))
            } else {
                dispatch(getUsers())
                dispatch(getTeams())
                dispatch(showPopup("confirmationPopup", "Edit Team was Successful"))
            }
        })
    }
}


export function createFolder(folderName, customerID) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/folders`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                folderName: folderName,
                customerID: customerID,
            })
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                throw new Error("Folder Creation Failed. Please Try Again")
                // good response flow
            } else {
                dispatch(getFolders())
                dispatch(recoverLogin())
                return dispatch(showPopup("confirmationPopup", "Folder Was Successfully Created"))
            }
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Folder Creation Failed. Please Try Again", false))
        })
    }
}


export function editFolder(folderID, name, customerId) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/folders`, {
            method: 'PATCH',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                folderName: name,
                ID: folderID,
                customerID: customerId
            })
        }).then(async (resp) => {
            if (resp.status !== 200) {
                let body = await resp.json()
                return dispatch(showPopup("confirmationPopup", body, false))
            } else {
                dispatch(getFolders())
                dispatch(recoverLogin())
                return dispatch(showPopup("confirmationPopup", "Edit Folder Was Successful"))
            }
        })
    }
}

export function deleteFolder(id) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Deleting Folder..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/folders/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then(async (resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                let body = await resp.json()
                return dispatch(showPopup("confirmationPopup", body, false))
            } else {
                dispatch(getFolders())
                dispatch(recoverLogin())
                return dispatch(showPopup("confirmationPopup", "Delete Folder Was Successful"))
            }
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Delete Folder Was Unsuccessful", false))
        })
    }
}

export function createDatabase(customerID, servertype, server, dbname, username, password, teamIds) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/databases`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                customerID: customerID,
                servertype: servertype,
                server: server,
                dbname: dbname,
                username: username,
                password: password,
                teamIds: teamIds
               
            })
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                throw new Error("Database Record Creation Failed. Please Try Again")
                // good response flow
            } else {
                dispatch(getDatabases())
                return dispatch(showPopup("confirmationPopup", "Database Record Was Successfully Created"))
            }
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Database Record Creation Failed. Please Try Again", false))
        })
    }
}


export function editDatabase(dbid, customerID, servertype, server, dbname, username, password, teamIds) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/databases`, {
            method: 'PATCH',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                ID: dbid,
                customerID: customerID,
                servertype: servertype,
                server: server,
                dbname: dbname,
                username: username,
                password: password,
                teamIds: teamIds
            })
        }).then(async (resp) => {
            if (resp.status !== 200) {
                let body = await resp.json()
                return dispatch(showPopup("confirmationPopup", body, false))
            } else {
                dispatch(getDatabases())
                return dispatch(showPopup("confirmationPopup", "Edit Database Record Was Successful"))
            }
        })
    }
}

export function testDatabase(dbid, customerID, servertype, server, dbname, username, password) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/admin/TestDatabase`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                ID: dbid,
                customerID: customerID,
                servertype: servertype,
                server: server,
                dbname: dbname,
                username: username,
                password: password,
                teamIds: []
            })
        })
    }
}

export function deleteDatabase(id) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Deleting Database Record ..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/databases/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then(async (resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                let body = await resp.json()
                return dispatch(showPopup("confirmationPopup", body, false))
            } else {
                dispatch(getDatabases())
                return dispatch(showPopup("confirmationPopup", "Delete Database Was Successful"))
            }
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Delete Database Was Unsuccessful", false))
        })
    }
}

export function sendEmail(firstName, lastName, email, phoneNumber, company, message) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Sending Email..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/email`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                FirstName: firstName,
                LastName: lastName,
                Email: email,
                PhoneNumber: phoneNumber,
                Company: company,
                Message: message,
            })
        }).then((resp) => {
            // handle bad exceptions and get the right error message
            if (resp.status !== 200) {
                throw new Error()
                // good response flow
            } else {
                dispatch(getUsers(false))
                return dispatch(showPopup("confirmationPopup", "Email Sent. You will be contacted shortly"))
            }
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Email Failed to be Sent", false))
        })
    }
}

export function dbupload(data) {
    return function (dispatch) {

        // get SAS Blob DB upload token
        fetch(`${process.env.REACT_APP_BACK_URL}/admin/DBUploadInfo/${data.get("file").name}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then(async (resp) => {
            if (resp.status !== 200) {
                throw new Error("Cloud Services Temporarily Unavailable")
            } else {
                let blobInfo = await resp.json()

                dispatch(showPopup("loadingPopup", "Uploading Database..."))

                if (`${process.env.REACT_APP_STORAGE}` == 'AWS')
                {
                    /*
                    const params = {
                        Bucket: "BUCKET_NAME", // The name of the bucket. For example, 'sample_bucket_101'.
                        Key: "KEY", // The name of the object. For example, 'sample_upload.txt'.
                        Body: "BODY", // The content of the object. For example, 'Hello world!".
                        EndPoint: blobInfo.url,
                        s3BucketEndpoint: true
                       
                    };

                    const client = new S3Client({ region: "REGION",  });
                    const results = await s3Client.send(new PutObjectCommand(params));
                                       

                    const toJSONTransform = new Transform({
                        writableObjectMode: true,
                        transform(chunk, encoding, callback) {
                            this.push(JSON.stringify(chunk) + '\n');
                            callback();
                        }
                    });

                    data.get("file").pipe(toJSONTransform);
                    */

                    /*
                    let blob = new Blob(data.file);

                    //const target = { key: blobInfo.blobName, body: blob.stream().getReader() };
                    const target = { Bucket: "iedev", Key: blobInfo.blobName, Body: file };

                    console.log(target);

                    try {
                        const parallelUploads = new Upload({
                                client: new S3Client({ endPoint: blobInfo.url, s3BucketEndpoint: true, useAccelerateEndpoint: true, region: "USeast1" }),
                                queueSize: 10,
                                partSize: 20971520, // 20mb
                                leavePartsOnError: false, // optional manually handle dropped parts
                                params: target,
                        });

                        parallelUploads.on("httpUploadProgress", (progress) => {
                            console.log(progress);
                        });

                        await parallelUploads.done();
                    } catch (e) {
                        console.log(e);
                        dispatch(showPopup("confirmationPopup", "Database Upload Failed", false));
                    }
                    */

                    let response = await new Promise(resolve => {
                        var xhr = new XMLHttpRequest();
                        xhr.open('PUT', blobInfo.acceleratedUrl, true);
                        xhr.setRequestHeader("Content-Type", 'application/octet-stream');

                        xhr.onload = function (e) {
                            resolve(xhr.response);
                        };
                        xhr.onerror = function () {
                            resolve(undefined);
                            dispatch(showPopup("confirmationPopup", "Database Upload Failed", false));
                        };

                        xhr.send(data.get("file"));
                    });

                  
                    console.log(`AWS Upload blob ${data.get("file").name} successfull`);
                }
                else {
                    let blobServiceClient = new BlobServiceClient(blobInfo.url);
                    let containerClient = blobServiceClient.getContainerClient(blobInfo.containerName);
                    let blockBlobClient = containerClient.getBlockBlobClient(blobInfo.blobName);

                    let uploadBlobResponse = await blockBlobClient.upload(data.get("file"), data.get("file").size);

                    console.log(`Azure Upload block blob ${data.get("file").name} successfull`, uploadBlobResponse.requestId);
                }

             

                blobInfo.customerDatabaseID = data.get("customerDatabaseID");
                console.log(blobInfo)
                // send msg to queue
                fetch(`${process.env.REACT_APP_BACK_URL}/admin/DBUploadInfo/`, {
                    method: 'POST',
                    headers: {
                        'accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
                    },
                    body: JSON.stringify(blobInfo)
                }).then(function (res) {
                    if (res.status != 200) {
                        dispatch(showPopup("confirmationPopup", "Database Upload Failed", false));
                    }
                    else
                    {
                        dispatch(showPopup("DBuploadCompleted"))
                        return dispatch(DBuploaded());
                    }
                    
                })
                    .catch(function (res) {
                        console.log(res);
                        dispatch(showPopup("confirmationPopup", "Database Upload Failed", false));
                    })

            }
        }).catch((ex) => {

            console.log(ex)
            return dispatch(showPopup("confirmationPopup", "Database Upload Failed", false));
        })
    }
}

export function webupload(data) {
     return function (dispatch) {
            var file;
            file = data.get("file");
            console.log(file, file.name);

            if (file.size > 0) {
                console.log('upload', file.name);
                // get SAS/presigned Blob DB upload token
                fetch(`${process.env.REACT_APP_BACK_URL}/admin/WebUploadInfo?fileName=${encodeURIComponent(file.name)}`, {
                    method: 'GET',
                    headers: {
                        'accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
                    },
                }).then(async (resp) => {
                    if (resp.status !== 200) {
                        throw new Error("Cloud Services Temporarily Unavailable")
                    } else {
                        let url = await resp.text()

                        if (`${process.env.REACT_APP_STORAGE}` == 'AWS') {
                            // get file content type, it has to match with presigned url signature

                            let extn = file.name.toLowerCase().split('.').pop();
                            let contentType = 'application/octet-stream';
                            if (extn == 'png' || extn == 'jpg' || extn == 'gif') contentType = "image/" + extn;

                            const XHR = new XMLHttpRequest()
                            XHR.open('PUT', url, false);
                            XHR.setRequestHeader("Content-Type", contentType);
                            XHR.send(file);

                            console.log(`AWS upload file ${file.name} successful`);

                        }
                        else {

                            let blobServiceClient = new BlobServiceClient(url);
                            let containerClient = blobServiceClient.getContainerClient("$web");
                            let blockBlobClient = containerClient.getBlockBlobClient(file.name);

                            let uploadBlobResponse = await blockBlobClient.upload(file, file.size);
                            console.log(`Azure upload block blob ${file.name} successful`, uploadBlobResponse.requestId);
                        }

                        dispatch(showPopup("confirmationPopup", "Logo File Uploaded Successfully"))

                    }
                }).catch((ex) => {

                    console.log(ex)
                    return dispatch(showPopup("confirmationPopup", "Web Upload Failed", false));
                })

            }
    }
}
    
export function logSearch(searchTxt) {

    fetch(`${process.env.REACT_APP_BACK_URL}/users/logsearch`, {
        method: 'POST',
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
        },
        body: JSON.stringify(searchTxt)           
    });
    
}


export function refreshCharts(startDate, endDate, type) {

    return fetch(`${process.env.REACT_APP_BACK_URL}/admin/usagecharts?startDate=${startDate}&endDate=${endDate}&type=${type}`, {
        method: 'GET',
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
        }
    }).then((resp) => {
        if (resp.status !== 200) {
            throw new Error("Services Temporarily Unavailable")
        } else {

            return resp.json()
        }
    }).then((data) => {
        console.log(data);
        return data;

    }).catch((ex) => {

        console.log(ex)
    });
}

export function downloadUsage(startDate, endDate) {
    return fetch(`${process.env.REACT_APP_BACK_URL}/admin/usagedownload?startDate=${startDate}&endDate=${endDate}`, {
        method: 'GET',
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
        }
    }).then((resp) => {
        if (resp.status !== 200) {
            throw new Error("Services Temporarily Unavailable")
        } else {

            return resp.blob()
        }
    }).then((blob) => {
        saveAs(blob, 'UsageReport' + startDate + '-' + endDate + '.csv')
       // return data;

    }).catch((ex) => {

        console.log(ex)
        showPopup("confirmationPopup", "Usage Download Failed", false);
    });

}

export function uploadFileData(data) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/admin/DBUploadInfo/${data["name"]}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        })
    }
}

export function activationCheck() {
    return { type: 'ACTIVATION_CHECK' }
}

export function showCustomers(payload) {
    return { type: 'SHOW_CUSTOMERS', payload }
}

export function showPermissions(payload) {
    return { type: 'SHOW_PERMISSIONS', payload }
}

export function showTeams(payload) {
    return { type: 'SHOW_TEAMS', payload }
}

export function showFolders(payload) {
    return { type: 'SHOW_FOLDERS', payload }
}

export function showDatabases(payload) {
    return { type: 'SHOW_DATABASES', payload }
}

export function loadUser(user) {
    return { type: 'LOAD_USER', user }
}

export function ssoFlag() {
    return { type: 'SSO_FLAG' }
}

export function setCustomerMessage(message) {
    return { type: 'SET_CUSTOMER_MESSAGE', message }
}

export function setCustomerNotes(notes) {
    return { type: 'SET_CUSTOMER_NOTES', notes }
}

export function showUsers(data, data2) {
    return { type: 'SHOW_USERS', data, data2}
}

export function loginSuccessful(user, role, customerName, customerMessage, customerNotes, custDBList, custFolderList) {
    return { type: 'LOGIN_USER', user, role, customerName, customerMessage, customerNotes, custDBList, custFolderList}
}

export function logoutUser() {
    localStorage.removeItem("jwt_token")
    return { type: 'LOGOUT_USER' }
}

export function flipUsersSwitch() {
    return {type: 'FLIP_USERS_SWITCH'}
}

export function ssoFail() {
    return {type: 'SSO_FAIL'}
}

export function DBuploaded() {
    return { type: 'DB_UPLOAD' }
}